"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFlexWrapper = exports.StyledInputField = exports.StyledPageSizeSelect = exports.StyledPageNumber = exports.StyledDivider = exports.StyledPaginationCount = exports.StyledIcon = exports.StyledMenuButton = exports.StyledPageSelectorWrapper = exports.StyledPaginationWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPaginationWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: ${({ theme }) => `${theme.spacing(0.75, 1.5, 0, 1.5)} `};
  align-items: center;
  border-top: ${({ theme }) => `1px solid ${theme.palette.grey[200]}`};
`;
exports.StyledPageSelectorWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;
exports.StyledMenuButton = (0, styled_components_1.default)(material_1.Button) `
  &.MuiButton-root {
    padding: 0;
    min-width: 0;
  }
`;
exports.StyledIcon = (0, styled_components_1.default)(ui_components_1.Icon) `
  transform: scale(0.85);
`;
exports.StyledPaginationCount = (0, styled_components_1.default)(ui_components_1.Typography) `
  margin: ${({ theme }) => `0 ${theme.spacing(0.75)}`};
`;
exports.StyledDivider = (0, styled_components_1.default)(material_1.Divider).attrs({ orientation: 'vertical' }) `
  height: ${({ theme }) => theme.spacing(5)};
  margin: 2px;
`;
exports.StyledPageNumber = styled_components_1.default.span `
  font-size: 0.875rem;
`;
exports.StyledPageSizeSelect = (0, styled_components_1.default)(ui_components_1.Dropdown) `
  height: ${({ theme }) => theme.spacing(5)};
  min-height: 0;
  min-width: ${({ theme }) => theme.spacing(11.25)};

  && {
    background-color: ${({ theme }) => theme.palette.common.white};
    &:hover {
      background-color: ${({ theme }) => theme.palette.common.white};
    }
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${({ theme }) => theme.palette.grey[500]};
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${({ theme }) => theme.palette.grey[500]};
  }

  .MuiSelect-icon {
    top: unset;
  }
`;
exports.StyledInputField = (0, styled_components_1.default)(ui_components_1.TextField) `
  && {
    .MuiInputBase-root {
      height: ${({ theme }) => theme.spacing(5)};
      min-height: 0;
      min-width: ${({ theme }) => theme.spacing(11.25)};
    }

    .MuiOutlinedInput-adornedEnd {
      padding: 0;
    }

    button.MuiButtonBase-root.MuiIconButton-root {
      padding: 4px;
    }
  }
`;
exports.StyledFlexWrapper = styled_components_1.default.div `
  display: flex;
`;
